import '../doctrine/doctrine.scss'; // FIXME: to remove when the style is fully componentized

const { registerLinkResolver } = require('gatsby-source-prismic-graphql');
const { linkResolver } = require('./src/utils/linkResolver');

registerLinkResolver(linkResolver);
